import { PostMethod, GetMethod } from '../../serviceHelper';

const getMethods = (service: 'Studio', controller: string) => ({
	AddState: new PostMethod<any, any>({
		service,
		controller,
		method: 'AddState'
	}),
	UpdateState: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateState'
	}),
	GetStateTree: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetStateTree'
	}),
	GetTags: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetTags'
	}),
	UpdateTags: new PostMethod<any, any>({
		service,
		controller,
		method: 'UpdateTags'
	}),
	CreateAction: new PostMethod<any, any>({
		service,
		controller,
		method: 'CreateAction'
	})
});

export { getMethods };
